import { render } from "./CounterParties.vue?vue&type=template&id=112a0c1c"
import script from "./CounterParties.vue?vue&type=script&lang=js"
export * from "./CounterParties.vue?vue&type=script&lang=js"

import "./CounterParties.vue?vue&type=style&index=0&id=112a0c1c&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__